import { render, staticRenderFns } from "./ContractCreate.vue?vue&type=template&id=3b54c2d8&scoped=true&"
import script from "./ContractCreate.vue?vue&type=script&lang=js&"
export * from "./ContractCreate.vue?vue&type=script&lang=js&"
import style0 from "./ContractCreate.vue?vue&type=style&index=0&id=3b54c2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54c2d8",
  null
  
)

export default component.exports